var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"center"},[_c('b-modal',{attrs:{"size":"xl","no-close-on-backdrop":"","scrollable":"","hide-footer":"","hide-header":"","id":"bv-loyalty-widget-modal"}},[_c('LoyaltyHome')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }